import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeResourceUrl } from '@angular/platform-browser';

interface WhatsNewModalData {
  contentUrl: SafeResourceUrl;
  title: string;
  width: number;
  height: number
}

@Component({
  selector: 'whats-new-modal',
  templateUrl: './whats-new-modal.component.html',
  styleUrls: ['./whats-new-modal.component.scss'],
  standalone: false,
})
export class WhatsNewModalComponent implements OnInit {
  frameHeight: string;
  frameWidth: string;
  acknowledge = false;
  readonly #dialogRef = inject<MatDialogRef<WhatsNewModalComponent>>(MatDialogRef);
  protected readonly matDialogData = inject<WhatsNewModalData>(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.frameHeight = this.matDialogData.height > 0 ? `${this.matDialogData.height}px;` : '600px';
    this.frameWidth = this.matDialogData.width > 0 ? `${this.matDialogData.width}px;` : '600px;';
  }

  onClose(): void {
    this.#dialogRef.close({ acknowledge: this.acknowledge });
  }
}
